import { Slider, withStyles } from '@material-ui/core'

export const SimilarityAccuracySlider = withStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main,
    height: 'fit-content',
  },
}))(Slider)
